
import React from "react";
import "./graph.css";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarController,
  LineController,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarController,
  LineController,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const GraphComponent = (props) => {

  



  const defaultOptions = {
    responsive: true,
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          autoSkip: true,
          padding: 0,
          maxRotation: 0,
          minRotation: 0,
        },
        autoSkip: false,
      },
      y: {
        min: 0,
        max: 120,
        stepSize: 20,
        grid: { display: false },
      },
    },
     animation: { duration: 200, easing: "easeOutQuart" },
    transitions: {
      active: { animation: { duration: 200 } },
      resize: { animation: { duration: 0 } },
    },
  };

  return (
    <div className={`${props?.className || ""} graph-container`}>
      <Chart
        type={props?.type || "bar"}
        data={props?.data}
        height={props?.height}
        width={props?.width}
        options={props?.options || defaultOptions}
        updateMode="active"
      />
    </div>
  );
};

export default GraphComponent;